import React from 'react';
import PropTypes from 'prop-types';
import LinkV2 from 'components/Link/LinkV2';
import s from './TrendingMarquee.scss';

const TrendingMarquee = props => {
  const { topSearches, title } = props;

  if (!(Array.isArray(topSearches) && topSearches.length > 0)) return null;

  const getItemGA = (itemText, index, wu) => {
    // const { gaCategory, gaAction } = this.props;
    const gaWithCategoryAction = `click-topSearches-${index}|${wu && wu}`;

    return gaWithCategoryAction;
  };

  return (
    <div className={s.trending_slider}>
      <div className={s.sliderHeading}>{title || 'Trending'}</div>
      <div className={s.trending_sliderContent}>
        <ul className={s.trending_slider_ani}>
          {topSearches.map((item, index) => (
            <li>
              {item.pillTitle || item.hl ? (
                <LinkV2
                  className={`keyword ${s.sliderItemHeading}`}
                  key={item.id}
                  to={item.wu || item.link}
                  // doNotChangeURL={item?.doNotChangeURL}
                  data-ga={`${getItemGA(
                    item.hl || item.title,
                    index + 1,
                    item.wu || item.link,
                  )}`}
                  ga4Data={[
                    {
                      event: 'user_click',
                      type: 'trending_topics',
                      label: item.pillTitle || item.hl,
                      story_no: index + 1,
                      category: 'seo-pills',
                    },
                  ]}
                  target={item.target === '_blank' ? item.target : ''}
                >
                  {item.pillTitle || item.hl}
                </LinkV2>
              ) : null}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

TrendingMarquee.propTypes = {
  topSearches: PropTypes.arrayOf({}),
  title: PropTypes.string,
};

TrendingMarquee.defaultProps = {
  topSearches: [],
  title: '',
};

export default TrendingMarquee;
